import { AppPalette } from '../../colors'

export const MuiSelect = {
  styleOverrides: {
    root: {
      // Select-main
      '&.select-main fieldset': {
        border: '0.5px solid rgba(201, 209, 217,0.6)',
        backgroundColor: 'rgb(33, 38, 45)',
        '&:hover': {
          border: '0.5px solid rgba(201, 209, 217,0.9)',
        },
      },
      '&.select-main:hover fieldset': {
        borderWidth: '0',
        border: '0.5px solid rgba(201, 209, 217,0.9)',
      },
      '&.select-main .MuiSelect-outlined': {
        color: AppPalette.GREY.darker,
        fontSize: '12px',
        fontWeight: '500',
        zIndex: '1',
      },
      // Select-non-border
      '&.select-non-border': {
        fontSize: '12px',
        height: '32px',
        fontWeight: '500',
        '.MuiOutlinedInput-notchedOutline': {
          borderColor: 'transparent',
          backgroundColor: 'rgba(0,0,0,0)',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          border: '0.5px solid rgba(201, 209, 217,0.9)',
          backgroundColor: 'rgb(33, 38, 45)',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: 'transparent',
        },
      },
      '&.select-non-border .MuiSelect-outlined , &.select-non-border .MuiSvgIcon-root':
        {
          zIndex: '1',
          fontSize: '12px',
          color: AppPalette.GREY.darker,
        },
    },
  },
}
